<div class="month-day" [class.today]="today" [class.before-today]="beforeToday" [ngClass]="availability">
  <div class="month-day-inner d-flex flex-column">
    <div class="day">
      <span *ngIf="startOfMonth">{{ day | epochUTC : 'MMM' }}</span>
      {{ day | epochUTC : 'D' }}
    </div>
    <div
      *ngIf="availability === availabilityTypes.UNAVAILABLE"
      class="flex-fill d-flex align-items-center justify-content-center text-danger text-sm"
    >
      <div class="text-bold" i18n>AI OFF</div>
    </div>
    <div *ngIf="availability === availabilityTypes.PARTIALLY_AVAILABLE" class="mt-auto text-xs">
      <div class="text-warning text-bold" i18n>AI Partially Off</div>
      <div class="text-light">
        {{ getTimeSlotTitle(items) }}
      </div>
    </div>
  </div>
</div>
